
export function TrunkShowsPage() {
    return (
        <>
        <div className="container-fluid g-0">
            <div className="row g-0">
                <div className="col-12 py-3 px-4 bb">
                    <h3>Trunk shows</h3>
                </div>
            </div>
        </div>
        <div className="container mt-5">
            <div className="row">
                <div className="col-12 col-md-6 offset-md-3">
                    <div className="row">
                        <div className="col-12 mb-4 text-center">
                            <p className="mb-1"><b>ATELIER</b></p>
                            <p>
                                Palazzo Capponi delle Rovinate <br />
                                Via Dei Bardi 36 <br />
                                Florence 50125, Italy <br />
                                +39 055 2341104 <br />
                                info@paolaquadretti.it <br />
                            </p>
                        </div>
                        <div className="col-12 col-md-3 mb-4 text-center">
                            <p className="mb-1"><b>July 6th-7th</b></p>
                            <p>South Hampton</p>
                        </div>
                        <div className="col-12 col-md-3 mb-4 text-center">
                            <p className="mb-1"><b>July 9th-10th</b></p>
                            <p>Nantucket</p>
                        </div>
                        <div className="col-12 col-md-3 mb-4 text-center">
                            <p className="mb-1"><b>July 13th</b></p>
                            <p>Niantic</p>
                        </div>
                        <div className="col-12 col-md-3 mb-4 text-center">
                            <p className="mb-1"><b>July 15th-17th</b></p>
                            <p>Newport</p>
                        </div>
                    </div>
                </div>
                <div className="col-12 col-md-6 offset-md-3 text-center mt-5">
                    <p className="text-muted">
                        Piquadri Srl <br />
                        Sede legale via santo spirito 11 Firenze 50125 <br />
                        Cod. fisc o P.Iva 06101730486 <br />
                        Capitale sociale 100.000,00 parte versata 25.000,00 <br />
                        Reg. Imp. FIRENZE e 06101730486 <br />
                        REA FI-600473 <br />
                    </p>
                </div>
            </div>
        </div>
        </>
    )
}